import { styled } from 'styled-components';

import { InputLabel, Typography } from '@mui/material';

export const PlaceholderText = styled(Typography)`
  font-size: 0.9rem;
  font-weight: 400;
  max-width: 100%;
`;

export const TruncatedInputLabel = styled(InputLabel)`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: calc(100% - 8px);
  pointer-events: auto;
`;
